import { TrialHeaderQueryHookResult } from "@generated/graphql";
import useIsCreate from "hooks/useIsCreate";
import { getCreateExaminationBaseData } from "pages/Testing/view/helpers";
import useCreateExamination from "pages/Testing/view/hooks/useCreateExamination";
import { CompetencyMapInputsCompetencyMap } from "pages/Testing/view/types";
import { Dispatch, SetStateAction } from "react";
import { InfoInputs } from "../types";
import useUpdateTrial from "./useUpdateTrial";

interface UseUpdateTestingProps {
  setIsEditing: Dispatch<SetStateAction<boolean>>;
  refetchTrialHeader: TrialHeaderQueryHookResult["refetch"];
}

const useUpdateTesting = ({ setIsEditing, refetchTrialHeader }: UseUpdateTestingProps) => {
  const isCreate = useIsCreate();

  const { updateTrialLoading, onUpdateTrial } = useUpdateTrial({ refetchTrialHeader });
  const { createExaminationLoading, onCreateExamination } = useCreateExamination();

  const handleUpdateTrial = ({ candidate, ...formData }: InfoInputs) => {
    if (isCreate) {
      onCreateExamination({
        ...getCreateExaminationBaseData({
          ...formData,
          competencyMap: formData.competencyMap as CompetencyMapInputsCompetencyMap,
        }),
        personalInput: {
          companyCandidateId: candidate.id,
        },
      });
    } else {
      onUpdateTrial({ formData, candidateId: candidate.id, setIsEditing });
    }
  };

  const updateLoading = updateTrialLoading || createExaminationLoading;

  return { updateLoading, handleUpdateTrial };
};

export default useUpdateTesting;
